import { Component, ViewChild, OnInit, OnChanges } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { TranslateService } from '@ngx-translate/core';
import { ReCaptchaComponent } from 'angular2-recaptcha';
import { ContextService } from '../../../services/contextService'
import { HttpService } from '../../../services/httpService'
import { FormField } from '../../../services/formService'
import { Validators, Validations } from '../../../services/validations'
import { RouterService } from '../../../services/routerService';
import { ConstantsService } from '../../../services/constantsService';
import { RegistrationModel } from '../../../models/userModel';

@Component({
  selector: 'registration-modal',
  templateUrl: './registration.html',
  styleUrls: ['./registration.scss']
})
export class Registration {
  @ViewChild(ReCaptchaComponent) captcha: ReCaptchaComponent;
  @ViewChild('lgModal') public registrationModal: ModalDirective;
  captchaVerified: boolean = true;
  REG_URL: string = '';
  registrationForm: RegistrationModel;
  landingContext: any;
  activeRole:string;
  signUpActive:boolean=false;
  constructor(private route: ActivatedRoute, private router: Router, private httpService: HttpService, private contextService: ContextService, private routerService: RouterService) {
    this.registrationForm = new RegistrationModel();
    this.registrationForm.reset();
  }
  // ngOnInit() {
  //   this.showModal(this);
  // }
  selectTab = function (index) {
    this.registrationForm.selectedTab.value = index;
    if (index === 1) {
      this.registrationForm.student_id.reset();
      this.REG_URL = "students/register"
    } else if (index === 2) {
      this.registrationForm.emp_id.reset();
      this.REG_URL = "staffs/register"
    }
  }
  handleCorrectCaptcha = function (event) {
    this.captchaVerified = true;
  }
  doRegistration = function () {
    if (this.registrationForm.validate()) {
      var appSpinner = this.contextService.getSpinnerContext();
      appSpinner.show("Registering...");
      if (this.activeRole == 'Teacher') {
        this.REG_URL = "staffs/register"
        // delete dataObject["selectedTab"];
        // delete dataObject["student_id"];
      } else if (this.activeRole == 'Student') {
        this.registrationForm.emp_id.reset();
        this.REG_URL = "students/register"
      }

      var dataObject = this.registrationForm.getData();

      this.httpService.post(this.REG_URL, dataObject).subscribe(
        res => {
          appSpinner.hide();
          this.registrationForm.reset();
          this.contextService.getAlertContext().showSuccess("Registration Successful.<br>Your Account is now active.", function () {
          });
          this.openLanding();

        },
        err => {
          appSpinner.hide();
          if (err.errorCode == 500) {
            err.errorText = "Unable to register.<br>Please check your credentials and try again.";
          }
          this.contextService.getAlertContext().showError(err.errorText);
        }
      );
    }
  }
  validate() {
    var isValid = false;
    if (this.registrationForm.validate()) {
      if (!this.captchaVerified) {
        this.contextService.getAlertContext().showError("Please Verify Captcha");
      } else {
        if (this.registrationForm.password.value === this.registrationForm.confirm_password.value) {
          isValid = true;
        } else {
          isValid = false;
          this.registrationForm.confirm_password.setError("Passwords do not match.");
        }
      }
    }
    return isValid;
  }

  registrationShown() {
    this.registrationForm.username.focus();
  }
  openLanding(){
    this.routerService.openLandingPage();
  }
  teacherToggle(){
    this.signUpActive=true;
    this.registrationForm.reset();
    this.registrationForm.selectedTab.value = 1;
    this.activeRole="Teacher"
  }
  studentToggle(){
    this.signUpActive=true;
    this.registrationForm.reset();
    this.registrationForm.selectedTab.value = 2;
    this.activeRole="Student"
  }
}
